import React, { FC } from 'react';

import { ControllerProps } from 'react-hook-form/dist/types/props';
import { Select } from '../components/Inputs';
import { useClsDocumentRTypesQuery } from '../api';

interface IDocTypes extends Pick<ControllerProps<'input'>, 'control' | 'name' | 'rules'> {
  label: string;
  error: boolean | undefined;
  disabled?: boolean;
}

const DocumentRTypes: FC<IDocTypes> = ({ label, error, control, name, rules, disabled }) => {
  const { data } = useClsDocumentRTypesQuery();
  return (
    <Select
      label={label}
      data={(data && data.classifierValues) || []}
      control={control}
      error={error}
      name={name}
      rules={rules}
      disabled={disabled}
    />
  );
};

export default DocumentRTypes;
